import React, { useEffect } from 'react';
import UbbeModalHeader from '../../global-components/modalHeader';
interface Props {
  setShowInsuranceModal: any;
}
function InsuranceModal({ setShowInsuranceModal }: Props) {
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const modal = document.getElementById('modal_content');
      if (modal && !modal.contains(event.target as Node)) {
        setShowInsuranceModal(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [setShowInsuranceModal]);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setShowInsuranceModal(false);
    }
  };

  return (
    <div
      className='modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      id='insurance_modal'
      tabIndex={-1}
      role='dialog'
      aria-labelledby='insuranceModalLabel'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div
        className='modal-dialog modal-dialog-centered modal-lg'
        role='document'
      >
        <div className='modal-content' id={'modal_content'}>
          <UbbeModalHeader headerText={'Insurance'} onClose={handleClose} />

          <div className='modal-body p-4'>
            <div>
              <ul className='lex-16-300' style={{ marginLeft: '-10px' }}>
                <li className='text-justify'>
                  Full replacement of goods that are lost or damaged during the
                  contract of carriage.
                </li>
                <li className='text-justify'>
                  The loss or damage must be in the carrier’s control for a
                  claim to be valid.
                </li>
                <li className='text-justify'>
                  Claims cannot be submitted for loss or damages that are caused
                  as a result of a natural disaster, war, strikes, riots and
                  civil commotions.
                </li>
                <li className='text-justify'>
                  An insurance certificate, which includes the insurance and
                  claim details, will be emailed to you within 1 business day.
                </li>
                <li className='text-justify'>
                  Claim support from our customer service support team.
                </li>
              </ul>
            </div>

            <div className='mt-4'>
              <label className='lex-16-300'>
                {' '}
                The cost is 0.30% of the amount you choose to insure, or a
                minimum of $15.00. See chart below for how your insurance cost
                could be calculated:
              </label>
            </div>

            <div className='my-4'>
              <table className='table'>
                <thead className=' ubbe-table-header'>
                  <tr className='table-header'>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      style={{ width: '50%' }}
                    >
                      Insurable Amount
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      style={{ width: '50%' }}
                    >
                      Cost
                    </th>
                  </tr>
                </thead>
                <tbody id='rows' className='legs'>
                  <tr className='align-middle'>
                    <td className='text-start '>$ 5,000.00</td>
                    <td className='text-start '>$ 15.00</td>
                  </tr>
                  <tr>
                    <td className='text-start '>$ 10,000.00</td>
                    <td className='text-start '>$ 30.00</td>
                  </tr>
                  <tr>
                    <td className='text-start '>$ 50,000.00</td>
                    <td className='text-start '>$ 150.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsuranceModal;
